import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, InputLabel, IconButton, TextField, Grid, Paper, CircularProgress, Select, MenuItem, FormControl } from '@material-ui/core'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { withStyles } from '@material-ui/core/styles';
import { useForm, Controller } from "react-hook-form";
import { FormattedMessage } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import SearchIcon from '@material-ui/icons/Search';
import { useDispatch, useSelector } from "react-redux";
import { NotificationActions, CreditCardPaymentActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        fontSize: '18px',
    },
    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 0 auto'
        }
    },
    amount: {
        fontSize: '14px',
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const creditCardPaymentSelector = (state) => state.CreditCardPayment;
const IdentitySelector = (state) => state.Identity;

const CreditCardPaymentList = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const creditCardPaymentActions = bindActionCreators(CreditCardPaymentActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { list, creditCardPaymentTotal, nowWainting } = useSelector(creditCardPaymentSelector);
    const { token } = useSelector(IdentitySelector);

    // React Hook Form
    const { control } = useForm();

    const { classes } = props;

    // 検索範囲
    // 期間（開始）
    const [startDt, setStartDt] = React.useState();
    // 期間（終了）
    const [endDt, setEndDt] = React.useState();
    // イシュア
    const [issuerId, setIssuerId] = React.useState();
    // 決済代行業者
    const [paymentAgencyId, setPaymentAgencyId] = React.useState();
    // 種別
    const [creditCardPaymentKind, setCreditCardPaymentKind] = React.useState();

    const listDefinition = {
        columns: [
            {
                // イシュア名
                title: <FormattedMessage id="Adjustment.Issuer" />,
                field: 'credit_card_issuer_name',
                filtering: false
            },
            {
                // 決済代行業者
                title: <FormattedMessage id="Adjustment.PaymentAgent" />,
                field: 'payment_agency_name',
                filtering: false
            },
            {
                // 種別
                title: <FormattedMessage id="Adjustment.Type" />,
                field: 'credit_card_payment_kind',
                filtering: false,
                lookup: {
                    1: "売上",
                    2: "チャージ",
                    3: "取消",
                },
            },
            {
                // 金額
                title: <FormattedMessage id="Adjustment.AmountOfMoney" />,
                field: 'credit_card_payment',
                type: 'currency',
                currencySetting: { currencyCode: 'JPY', minimumFractionDigits: 0, maximumFractionDigits: 0 },
                filtering: false
            },
        ]
    };

    /**
     *
     * Similar to componentDidMount and componentDidUpdate:
     * 
     * 第2引数に[]を渡すとマウント時のみ呼び出される
     */
    useEffect(() => {
        if (props.refresh == null || props.refresh == true) {
            // 一覧を初期化
            creditCardPaymentActions.initListInfo();
        }
    }, []);

    /**
     * 
     * 検索ボタン押下時の処理
     * 
     */
    const onSearchClick = () => {
        // 検索条件チェック
        // 検索日（大小関係）
        if (startDt != "" && startDt != null && startDt != undefined &&
            endDt != "" && endDt != null && endDt != undefined) {
            // UTC変換
            const sdt = new Date(startDt);
            const edt = new Date(endDt);
            if (sdt.getTime() > edt.getTime()) {
                notificationActions.showError("検索条件「期間」の日付の大小関係が正しくありません。");
                return;
            }
        }

        // クレジットカードの売上明細リストを取得
        creditCardPaymentActions.listCreditCardPayments(token, startDt, endDt, issuerId, paymentAgencyId, creditCardPaymentKind)
            .then(data => {
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     * 
     * 詳細ボタン押下時の処理
     * 
     * @param data 選択された行のデータ 
     */
    const onDetailClick = (dtl) => {
        // クレジットカードの売上明細（日別）リストを取得
        creditCardPaymentActions.listCreditCardPaymentsDaily(token, startDt, endDt, dtl.credit_card_issuer_id, dtl.payment_agency_id, dtl.credit_card_payment_kind)
            .then(data => {
                props.onDetail(startDt, endDt, dtl);
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const { name, value } = e[0].target;
        if (name.startsWith('start_dt')) {
            setStartDt(value);
        }
        else if (name.startsWith('end_dt')) {
            setEndDt(value);
        }
        else if (name.startsWith('credit_card_issuer_id')) {
            setIssuerId(value);
        }
        else if (name.startsWith('payment_agency_id')) {
            setPaymentAgencyId(value);
        }
        else if (name.startsWith('credit_card_payment_kind')) {
            setCreditCardPaymentKind(value);
        }
        return value;
    }

    const placeholder = <FormattedMessage id="Table.Action" />;

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <form className={classes.form} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <div className={classes.infoTitle}>
                                <Typography id="infoTitle" component="h2" variant="inherit"><FormattedMessage id="Adjustment.CreditCardPayment" /></Typography>
                                <div>
                                    <Button fullWidth id="searchButton" variant="contained" size="medium" color="primary"
                                        startIcon={<SearchIcon />}
                                        onClick={onSearchClick}><FormattedMessage id="Button.Search" /></Button>
                                </div>
                            </div>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <InputLabel component="legend"><FormattedMessage id={"Adjustment.Period"} /></InputLabel>
                            </Grid>
                            <Grid item xs={6}>
                                <Controller
                                    name="start_dt"
                                    control={control}
                                    onChange={onChange}
                                    defaultValue={startDt}
                                    as={<TextField fullWidth variant="outlined"
                                        id="adjustment-startdate"
                                        labelId="adjustment-label-startdate"
                                        label={<FormattedMessage id={"Merchant.FromDate"} />}
                                        type="date"
                                        className={classes.textField}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />} />
                            </Grid>
                            <Grid item xs={6}>
                                <Controller
                                    name="end_dt"
                                    control={control}
                                    onChange={onChange}
                                    defaultValue={endDt}
                                    as={<TextField fullWidth variant="outlined"
                                        id="adjustment-enddate"
                                        labelId="adjustment-label-enddate"
                                        label={<FormattedMessage id={"Merchant.ToDate"} />}
                                        type="date"
                                        className={classes.textField}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />} />
                            </Grid>

                            <Grid item xs={6}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel id="issuer-id-label"><FormattedMessage id={"Adjustment.Issuer"} /></InputLabel>
                                    <Controller
                                        name="credit_card_issuer_id"
                                        control={control}
                                        onChange={onChange}
                                        defaultValue={issuerId}
                                        as={<Select
                                            labelId="issuer-id-label"
                                            id="issuer-id"
                                            label={<FormattedMessage id={"Adjustment.CreditCard"} />}>
                                            <MenuItem key='' value=''>＜未選択＞</MenuItem>
                                            <MenuItem key='2s10035' value='2s10035'>クレディセゾン</MenuItem>
                                        </Select>}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel id="payment-agency-id-label"><FormattedMessage id={"Adjustment.PaymentAgent"} /></InputLabel>
                                    <Controller
                                        name="payment_agency_id"
                                        control={control}
                                        onChange={onChange}
                                        defaultValue={paymentAgencyId}
                                        as={<Select
                                            labelId="payment-agency-id-label"
                                            id="payment-agency-id"
                                            label={<FormattedMessage id={"Adjustment.PaymentAgent"} />}>
                                            <MenuItem key='' value=''>＜未選択＞</MenuItem>
                                            <MenuItem key='100001' value='100001'>GMOチャージ用</MenuItem>
                                            <MenuItem key='100002' value='100002'>GMO一般店舗向け</MenuItem>
                                            <MenuItem key='100003' value='100003'>GMOタクシー向け</MenuItem>
                                            <MenuItem key='100004' value='100004'>GMO大規模小売向け</MenuItem>
                                        </Select>}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={6}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel id="credit-card-payment-kind-label"><FormattedMessage id={"Adjustment.Type"} /></InputLabel>
                                    <Controller
                                        name="credit_card_payment_kind"
                                        control={control}
                                        onChange={onChange}
                                        defaultValue={creditCardPaymentKind}
                                        as={<Select
                                            labelId="credit-card-payment-kind-label"
                                            id="credit-card-payment-kind"
                                            label={<FormattedMessage id={"Adjustment.Type"} />}>
                                            <MenuItem key='' value=''>＜未選択＞</MenuItem>
                                            <MenuItem key='1' value='1'>売上</MenuItem>
                                            <MenuItem key='2' value='2'>チャージ</MenuItem>
                                            <MenuItem key='3' value='3'>取消</MenuItem>
                                        </Select>}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                            </Grid>

                            <Grid item xs={4}>
                            </Grid>
                            <Grid item xs={2}>
                                <Typography component="h4" variant="inherit">{<FormattedMessage id="Adjustment.TotalFee" />}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography component="h4" variant="inherit">{creditCardPaymentTotal}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            <MaterialTable
                title={<Typography component="h2" variant="inherit">{<FormattedMessage id="Adjustment.ResultsTitle" />}</Typography>}
                columns={listDefinition.columns}
                data={list}
                options={{
                    search: false,
                    filtering: true,
                    actionsColumnIndex: -1,
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: ''
                    },
                }}
                components={{
                    // 右端のアクションボタン列（日別画面遷移ボタン）
                    Action: actionProps => {
                        if (actionProps.action.tooltip !== "Add") {
                            return (
                                <IconButton aria-label="detail" onClick={() => onDetailClick(actionProps.data)}>
                                    <ArrowForwardIosIcon />
                                </IconButton>
                            )
                        } else {
                            return (
                                <div></div>
                            )
                        }
                    },
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(CreditCardPaymentList);
